import styled from 'styled-components';
import { colors, breakpoints } from 'app/variables';

export const InfoBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  width: 100%;
`;
export const InlineFlexContainer = styled.div`
  display: flex;
`;
export const FacilityNameContainer = styled.div`
  display: flex;
  font-size: 24px;
  padding-bottom: 1rem;
`;
export const InlineIcon = styled.div.attrs(() => ({
  'aria-hidden': true,
}))`
  flex: 0 0 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  & svg {
    width: 30px !important;
    height: 30px !important;
  }
`;
export const InlineName = styled.div`
  position: relative;
  padding-left: 15px;
  align-self: center;
  font-size: initial;
  width: 100%;
`;
export const FacilityName = styled.a`
  position: relative;
  padding-left: 15px;
  text-decoration: none;
  font-size: 2rem;
  font-weight: 800;
  color: ${colors.pacificBlue};

  ${({ asButton }) =>
    asButton &&
    `
  color: ${colors.white};
  font-size: 1rem;
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
  padding: 1.2rem 3rem;
  border-radius: 5px;
  background: ${colors.pacificBlue};

  &:hover::before {
    transform: translateX(-2.5px) rotate(45deg) scale(1.05);
    transition: 0.2s linear;
  }
`}
  &::before {
    ${({ asButton }) =>
      asButton &&
      `
    border: 2px solid currentColor;
    border-right: 0;
    border-top: 0;
    content: '';
    display: block;
    height: 10px;
    margin-top: -10px;
    pointer-events: none;
    position: absolute;
    top: 57%;
    left: 1.5rem;
    transform: rotate(45deg);
    transform-origin: center;
    width: 10px;
  `}
  }
  @media (max-width: ${breakpoints.widescreen}) {
    max-width: 36%;
  }
  @media (max-width: ${breakpoints.mediumDesktop}) {
    max-width: 30%;
  }
`;
export const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
export const AddressContactContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  flex-direction: ${({ containsEmail }) => (containsEmail ? 'column' : 'row')};
  max-width: 36%;

  @media (max-width: ${breakpoints.mediumDesktop}) {
    flex-direction: column;
    max-width: 30%;
  }
`;
export const ContactLink = styled.a`
  text-decoration: none;
  color: ${colors.pacificBlue};
`;
export const OpeningHoursList = styled.div`
  display: flex;
  gap: 1rem;
  padding-top: 1.25rem;
  max-width: 33%;
`;
export const DaysTxt = styled.div`
  flex: 1 1 40%;
`;
export const HoursTxt = styled.div`
  flex: 1 1 60%;
`;
